import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip tracking for admin pages
    if (location.pathname.startsWith('/admin')) return;
    axios.post(`${BACKEND_URL}/api/track`, { path: location.pathname }).catch(() => {});
  }, [location.pathname]);

  return null;
};

export default PageTracker;
